export default "__VITE_ASSET__BqmTbMKB__"